import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true
    },
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  public date: NgbDate = {} as any;
  private _minDate: NgbDate;
  private _maxDate: NgbDate;
  @Input() set maxDate(value: NgbDate) {
    if (this.date.day && this.date.after(value)) {
      this.date = value;
      this.onChange(this.date);
    }
    this._maxDate = value;
  };
  @Input() set minDate(value: NgbDate) {
    if (this.date.day && this.date.before(value)) {
      this.date = value;
      this.onChange(this.date);
    }
    this._minDate = value;
  };

  @Input() placeholder: string = "";

  constructor() { }

  ngOnInit() {
  }

  get minDate(): NgbDate {
    return this._minDate;
  }

  get maxDate(): NgbDate {
    return this._maxDate;
  }

  // Control value accessor callbacks
  onChange: any = () => { };
  onTouch: any = () => { };

  // Control value accessor methods
  writeValue(obj: any) {
    if (obj) {
      this.date = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  onProcess(evt) {
    this.date = evt;
    this.onChange(this.date);
  }

}
